<template>
  <span class="memory">
    {{value.value}} {{unit}}
  </span>
</template>

<script>
import { toLower } from 'lodash';

export default {
  name: 'memory',
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    unit() {
      return this.$t(`units.memory.${toLower(this.value.unit)}`);
    },
  },
};
</script>



// WEBPACK FOOTER //
// Memory.vue?0f099958